import { render } from "./HdFormGroup.vue?vue&type=template&id=bbdd6af4"
import script from "./HdFormGroup.vue?vue&type=script&lang=js"
export * from "./HdFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__